export default "__VITE_ASSET__CWcGT_K3__"